import { Controller } from "@hotwired/stimulus"

// Submits a remote form via fetch and toggles the button to success state.
// Used on renewal index for inline subscription/membership period forms.
// Manually collects inputs associated via the HTML form attribute since
// FormData doesn't reliably include them in all browsers.
export default class extends Controller {
  static values = { renewal: String, id: Number }

  submit(event) {
    event.preventDefault()
    const key = `${this.renewalValue}_${this.idValue}`
    const formId = `form_${key}`
    const form = document.getElementById(formId)
    if (!form) return

    // Collect inputs inside the form AND inputs linked via form="formId" attribute
    const formData = new FormData(form)
    document.querySelectorAll(`[form="${formId}"]`).forEach(input => {
      if (input.name) formData.set(input.name, input.value)
    })

    const csrfToken = document.querySelector('meta[name="csrf-token"]')

    fetch(form.action, {
      method: 'POST',
      headers: csrfToken ? { 'X-CSRF-Token': csrfToken.content } : {},
      body: formData
    })
    .then(() => {
      this.element.classList.remove('btn-primary')
      this.element.classList.add('btn-success')
    })
  }
}
